import React from "react";
import {uid} from "react-uid";

class Util {
  static newLineToBrTag = (content) => {
    return content && content.split("\n").map((text, index) => {
      return (
        <span key={uid(text, index)}>
          {text}
          <br />
        </span>
      );
    });
  }

  static arrayInGroupOfArray(list, chunk_size) {
    let results = [];
    while (list.length) {
      results.push(list.splice(0, chunk_size));
    }
    return results;
  }
}

export default Util;
